import Footer from "@/components/Footer";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#0a0908] text-[#F7F4EE]" data-testid="terms-page">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        <span className="av-eyebrow">Documento legale</span>
        <h1 className="font-serif-display text-4xl sm:text-6xl mt-3 leading-[1.05]">
          Termini e <span className="italic text-[#E5A93C]">condizioni</span>
        </h1>
        <p className="text-[#A39E93] mt-4 text-sm">
          Ultimo aggiornamento: 19 settembre 2026
        </p>

        <div className="mt-10 space-y-6 text-[#F7F4EE]/90 leading-relaxed text-sm sm:text-base">
          <p>
            L'utilizzo del portale <strong>NMA Agency</strong> comporta
            l'accettazione integrale dei presenti termini. Il portale è di
            proprietà di <strong>NMA Agency di Massimiliano Napolitano</strong>{" "}
            (di seguito "NMA").
          </p>

          <Section title="1 · Oggetto del servizio">
            <p>
              NMA mette a disposizione un catalogo di artisti e spettacoli e
              permette a enti, comuni, associazioni e privati di richiedere
              preventivi personalizzati. NMA agisce da{" "}
              <strong>agenzia intermediaria</strong> tra il cliente e l'artista;
              il rapporto contrattuale definitivo si perfeziona con la firma del
              preventivo e il versamento dell'acconto.
            </p>
          </Section>

          <Section title="2 · Registrazione e account">
            <p>
              L'utente si impegna a fornire dati veritieri, aggiornati e
              completi. È vietato condividere credenziali di accesso. In caso di
              uso improprio, NMA si riserva di sospendere l'account.
            </p>
          </Section>

          <Section title="3 · Preventivi e prenotazioni">
            <ul className="list-disc pl-6 space-y-1">
              <li>I preventivi hanno validità <strong>30 giorni</strong> salvo diversa indicazione.</li>
              <li>La conferma richiede firma digitale del preventivo e versamento acconto (%) come indicato in ogni preventivo.</li>
              <li>Prezzi indicati sul catalogo sono indicativi e possono variare in base a data, luogo, service tecnico e SIAE.</li>
              <li>In caso di cancellazione: <strong>60+ giorni prima</strong> rimborso 100% acconto; <strong>30-59 giorni</strong> 50%; <strong>meno di 30 giorni</strong> l'acconto è trattenuto per copertura organizzativa.</li>
            </ul>
          </Section>

          <Section title="4 · Candidature artisti">
            <p>
              Gli artisti che si candidano al roster accettano che i propri dati
              e materiali (foto, video, bio) siano valutati dalla direzione NMA.
              La candidatura non costituisce impegno contrattuale.
            </p>
          </Section>

          <Section title="5 · Proprietà intellettuale">
            <p>
              Il marchio "NMA Agency", il logo e i contenuti del portale (testi,
              grafiche, layout) sono di proprietà esclusiva di NMA. I loghi degli
              artisti e dei partner appartengono ai rispettivi titolari.
            </p>
          </Section>

          <Section title="6 · Limitazione di responsabilità">
            <p>
              NMA si impegna a mantenere il portale funzionante ma non
              garantisce disponibilità ininterrotta. NMA non è responsabile per
              danni derivanti da malfunzionamenti di servizi terzi (Stripe,
              email provider, hosting) o da eventi di forza maggiore.
            </p>
          </Section>

          <Section title="7 · Legge applicabile e foro competente">
            <p>
              I presenti termini sono regolati dalla legge italiana. Per
              qualsiasi controversia il foro competente è quello di{" "}
              <strong>Torino</strong> (sede legale del Titolare in Rivara, TO),
              salvo diritto del consumatore ex art. 66 bis Codice del Consumo
              di adire il foro della propria residenza.
            </p>
          </Section>

          <Section title="8 · Contatti">
            <p>
              Per qualsiasi comunicazione:{" "}
              <a
                href="mailto:napolitanomaxagency@live.com"
                className="text-[#E5A93C] underline"
              >
                napolitanomaxagency@live.com
              </a>{" "}
              — WhatsApp Business +39 347 318 8828.
            </p>
            <p className="mt-2 text-sm text-[#A39E93]">
              NMA Agency di Massimiliano Napolitano · C.F. NPLMSM74B11F924E · Sede legale: Via Alfredo D'Andrade 5, 10080 Rivara (TO), Italia.
            </p>
          </Section>
        </div>
      </section>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="border-l-2 border-[#E5A93C]/40 pl-5">
      <h2 className="font-serif-display text-xl text-[#F7F4EE]">{title}</h2>
      <div className="mt-2 text-[#F7F4EE]/85">{children}</div>
    </section>
  );
}
